import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'
import { getTerms } from '@/lib/hooks/services/useGetTerms'
import type { CustomerType } from '@/store/types/user'
import { mixpanelService } from '../initializeMixPanel'
import { MixpanelEvent } from '../mixpanelEvent'
import {
  generateProductEventData,
  type MixpanelProductData,
} from '../helpers/generateCartEventData'

type TrackProductSelectionParams = {
  product: CosmicProductType
  selectedVariation: CosmicVariationType
  eventLocation: string
  action: string
  customerType: CustomerType
  currencyCode: string
  cardIndex?: number
  searchTerm?: string
  topBannerName?: string
}

export const trackShoSelectProduct = ({
  product,
  selectedVariation,
  eventLocation,
  action,
  customerType,
  currencyCode,
  cardIndex,
  searchTerm,
  topBannerName,
}: TrackProductSelectionParams) => {
  const eventData: Record<string, string | number | MixpanelProductData[]> = {
    event_location: eventLocation,
    action,
    cart: generateProductEventData(
      product,
      selectedVariation,
      currencyCode || 'USD',
      getTerms({
        forCustomerType: customerType,
        pricingData: selectedVariation?.pricing,
      })?.priceEach || 0,
      cardIndex !== undefined ? { index: cardIndex } : undefined,
    ),
  }

  if (searchTerm) {
    eventData.search_term = searchTerm
  }

  if (topBannerName) {
    eventData.top_banner_name = topBannerName
  }

  return mixpanelService.trackEvent(MixpanelEvent.SELECT_PRODUCT, eventData)
}
